<template>
  <div 
    v-if="!loading"
    class="hero-background-slider home__hero">
    <div
      v-swiper-heroes="swiperActiveIndex"
      class="swiper-container swiper-container--hero-background-slider" >
      
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div 
          v-for="(slide, index) of slidesArray"
          :key="index"
          class="swiper-slide">
          <HeroBackground :srcSetImages="slide.srcSetImages"/>
          <HeroTextSlider
            :heroH1="slide.heroH1"
            :heroH2="slide.heroH2"
            :heroP="slide.heroP"
            :heroLink="slide.heroLink"
            :heroLinkText="slide.heroLinkText"/>
        </div>
        <!-- Fine Slides -->
      </div>

      <!-- Add Pagination -->
      <div class="swiper-pagination"></div>

    </div>
  </div>
  <div 
    v-else
    style="height:100vh; background-color: #FFF;">
    &nbsp;
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import swiper from './swiper'
import HeroBackground from '@/components/HeroBackground/HeroBackground.vue'
import HeroTextSlider from '@/components/HeroBackgroundSlider/HeroTextSlider/HeroTextSlider.vue'

export default {
  name: 'HeroBackgroundSlider',
  components: {
    HeroTextSlider,
    HeroBackground
  },
  mixins: [swiper],
  data: () => ({
    loading: true
  }),
  computed: {
    ...mapGetters('contentful', [
      'fullScreenGalleries'
    ]),
    slidesArray: {
      get () {
        return this.fullScreenGalleries
          .filter(gallery => gallery.fields.whichPage === 'homepage')
          .reduce((accumulator, gallery) => {
            accumulator.push({
              srcSetImages: {
                '640': `${gallery.fields.imageSlidePortrait.fields.file.url}`,
                '1024': `${gallery.fields.imageSlide.fields.file.url}?w=1024&fit=scale`,
                '1440': `${gallery.fields.imageSlide.fields.file.url}?w=1440&fit=scale`,
                '1920': `${gallery.fields.imageSlide.fields.file.url}?w=1920&fit=scale`
              },
              heroH1: typeof gallery.fields.heroH1 !== 'undefined' ? gallery.fields.heroH1 : undefined,
              heroH2: typeof gallery.fields.heroH2 !== 'undefined' ? gallery.fields.heroH2 : undefined,
              heroP: typeof gallery.fields.heroP  !== 'undefined' ? gallery.fields.heroP : undefined,
              heroLink: typeof gallery.fields.heroLink !== 'undefined' ? this.$_createLinkUrl(gallery.fields.heroLink) : '',
              heroLinkText: typeof gallery.fields.heroLinkText !== 'undefined' ? gallery.fields.heroLinkText : ''
            })
            return accumulator
          }, [])
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadFullScreenGalleries'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadFullScreenGalleries()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_createLinkUrl (entry) {
      const contentTypeId = entry.sys.contentType.sys.id
      const map = {
        'products': 'prodotto',
        'category': 'categoria',
        'posts': 'cosa-usare-per',
        'tags': 'tag'
      }
      return typeof map[contentTypeId] === 'undefined' ? `/${entry.fields.slug}/` : `/${map[contentTypeId]}/${entry.fields.slug}/`
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>